module.exports = function() {
  return new Worker(__webpack_public_path__ + "e51e415905fc94c1ec67.worker.js");
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/worker-loader/dist/cjs.js!./node_modules/pdfjs-dist/es5/build/pdf.worker.js
// module id = 659
// module chunks = 0